module.exports = __webpack_public_path__ + "static/media/green_mark.57ef8e66.svg";